export interface ListaDeCodigos {
  readonly campo: string;
  readonly codigos: readonly string[];
}

function codigosDe(valor: unknown): readonly string[] {
  return Array.isArray(valor) ? valor.filter((codigo): codigo is string => typeof codigo === 'string') : [];
}

/** As listas de código da regra: `escopo.codigos` e toda lista de texto do efeito (`TP-055`). */
export function listasDeCodigos(escopo: unknown, efeito: unknown): readonly ListaDeCodigos[] {
  const listas: ListaDeCodigos[] = [];
  if (escopo !== null && typeof escopo === 'object') {
    const codigos = codigosDe((escopo as { codigos?: unknown }).codigos);
    if (codigos.length > 0) listas.push({ campo: 'codigos', codigos });
  }
  if (efeito !== null && typeof efeito === 'object') {
    for (const [campo, valor] of Object.entries(efeito as Record<string, unknown>)) {
      const codigos = codigosDe(valor);
      if (codigos.length > 0) listas.push({ campo, codigos });
    }
  }
  return listas;
}
